import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { PODCAST } from '../../interfaces/podcast.interface';
import { PodcastService } from '../../services/podcast.service';

import { FacebookService } from 'src/app/shared/sharing/facebook.service';

@Component({
  selector: 'app-podcast',
  templateUrl: './podcast.component.html',
  styleUrls: ['./podcast.component.css']
})
export class PodcastComponent implements OnInit {

  currentPodcast = 0
  datepipe: DatePipe = new DatePipe('es-ES')

  urlVideoSafe: any;

  podcast: PODCAST = {};

  id_next: number = 0
  id_prev: number = 0

  fecha: string | null = ''

  videoURI: SafeResourceUrl | undefined;


  constructor(
    private fbService: FacebookService,
    private podcastService: PodcastService,
    public sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false; // Can reload the page
    this.route.params.subscribe(params => {
      this.currentPodcast = params['id']
    });
  }
  public safeURL(value: any): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  shareOnFacebook(): void {
    const url = window.location.href;
    // const title = 'Título de tu página';
    // const imageUrl = 'URL de tu imagen';

    // this.fbService.share(url, title, imageUrl);
    // const url = 'https://retailco.es/#/retalk/8'; // La URL de la noticia actual
    const title = 'Título de la Noticia'; // Título dinámico
    const imageUrl = 'URL de la Imagen'; // URL de la imagen dinámica
    const description = 'Descripción de la Noticia'; // Descripción dinámica

    // Abre una ventana para compartir en Facebook
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      'pop', 'width=600, height=400, scrollbars=no');
  }
  shareOnLinkedin(): void {
    const url = window.location.href;

    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`);
  }

  ngOnInit(): void {
    this.titleService.setTitle('retailCo #Retalk: ' + this.podcast.title);

    this.podcastService.getPodcast(this.currentPodcast).subscribe(
      (resp) => {
        this.podcast = resp
        this.fecha = this.podcast.date ? this.podcast.date : ''
        this.fecha = this.datepipe.transform(this.fecha, 'dd MMMM yyyy')

        if (resp.next) {
          if (resp.next.id != null &&
            // resp.id !== 19
            (!resp.next.datePublishing || resp.next.datePublishing === "" || new Date(resp.next.datePublishing) < new Date())
          ) {
            this.id_next = resp.next.id
          }
        }
        if (resp.prev) {
          if (resp.prev.id != null
          ) { this.id_prev = resp.prev.id }
        }

        this.videoURI = this.safeURL(this.podcast.podUrl)
        this.urlVideoSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.podcast.podUrl!);

        this.titleService.setTitle('retailCo Retalk: ' + this.podcast.title);
      },
      (err) => { }
    )


  }

}
